var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"allow-empty":false,"disabled":_vm.disabled,"loading":_vm.isLoading,"max-height":600,"multiple":true,"options":_vm.items,"required":_vm.required,"searchable":true,"deselect-label":"Remover seleção","label":"name","placeholder":"Selecione uma ou mais opções","select-label":"Selecionar","track-by":"name"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc17fd6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormBuilder/Fields/Cid10.vue
// module id = 875
// module chunks = 1